import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';

const BotonMetroMinuto = () => {

   const navigate = useNavigate();

   const handleClick = () => {
    navigate('/metrominuto');
  };
  
  return (
    <StyledWrapper>
      <button className="continue-application" onClick={handleClick}>
        <div>
          <div className="walking-icon">
            <svg viewBox="0 0 24 24">
              {/* Cabeza */}
              <circle cx="12" cy="4" r="2" fill="currentColor" />
              {/* Cuerpo */}
              <path d="M12,6 L12,12" stroke="currentColor" strokeWidth="2" fill="none" />
              {/* Pierna izquierda */}
              <path d="M12,12 L9,18" stroke="currentColor" strokeWidth="2" fill="none" />
              {/* Pierna derecha */}
              <path d="M12,12 L15,18" stroke="currentColor" strokeWidth="2" fill="none" />
            </svg>
          </div>
        </div>
        Co'ox
      </button>
    </StyledWrapper>
  );
};

const walk = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(2px); }
  50% { transform: translateX(0); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
`;

const StyledWrapper = styled.div`
  .continue-application {
    --color: #fff;
    --background: #404660;
    --background-hover: #3A4059;
    --background-left: #2B3044;
    border: none;
    outline: none;
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    padding: 17px 29px 17px 69px;
    transition: background 0.3s;
    color: var(--color);
    background: var(--bg, var(--background));
  }

  /* Contenedor izquierdo para el icono (persona caminando) */
  .continue-application > div {
    top: 0;
    left: 0;
    bottom: 0;
    width: 53px;
    position: absolute;
    overflow: hidden;
    border-radius: 5px 0 0 5px;
    background: var(--background-left);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Icono de la persona caminando */
  .continue-application > div .walking-icon svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
    transition: transform 0.3s;
  }

  /* Animación al hacer hover: simula movimiento de caminar */
  .continue-application:hover > div .walking-icon svg {
    animation: ${walk} 0.6s infinite;
  }

  /* Detalles decorativos similares */
  .continue-application:before,
  .continue-application:after {
    content: "";
    position: absolute;
    width: 10px;
    height: 2px;
    border-radius: 1px;
    background: var(--color);
    transform-origin: 9px 1px;
    transform: translateX(var(--cx, 0)) scale(0.5) rotate(var(--r, -45deg));
    top: 26px;
    right: 16px;
    transition: transform 0.3s;
  }

  .continue-application:after {
    --r: 45deg;
  }

  .continue-application:hover {
    --cx: 2px;
    --bg: var(--background-hover);
  }
`;

export default BotonMetroMinuto;
